import React from 'react';
import { Card, CardContent } from '../ui/card';
import { brl, pct, num, Delta } from '../logistics/format';

const CARDS = [
  { key: 'receita', label: 'Receita de produtos', fmt: brl },
  { key: 'unidades', label: 'Unidades vendidas', fmt: num },
  { key: 'produtos', label: 'Produtos distintos vendidos', fmt: num },
  { key: 'itens_por_pedido', label: 'Itens por pedido', fmt: num },
  { key: 'concentracao_top10', label: 'Top 10 produtos', fmt: (v) => (v == null ? '—' : `${pct(v)} da receita`) },
];

export const ProductCards = ({ cards }) => (
  <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-5" data-testid="products-cards">
    {CARDS.map((c) => {
      const d = cards[c.key] || {};
      return (
        <Card key={c.key} data-testid={`products-card-${c.key}`}>
          <CardContent className="p-5" style={{ containerType: 'inline-size' }}>
            <p className="text-xs text-muted-foreground uppercase tracking-wider whitespace-nowrap overflow-hidden text-ellipsis">{c.label}</p>
            <p className="font-mono font-bold mt-2 whitespace-nowrap" style={{ fontSize: 'clamp(1.05rem, 9cqi, 1.7rem)' }} data-testid={`products-card-${c.key}-value`}>{c.fmt(d.value)}</p>
            <p className="text-xs mt-1 whitespace-nowrap overflow-hidden text-ellipsis">
              <Delta value={d.delta_pct} /> <span className="text-muted-foreground">· antes: {c.fmt(d.previous)}</span>
            </p>
          </CardContent>
        </Card>
      );
    })}
  </div>
);
